import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { FaqCategoryService } from '../faq-category.service';
import { FaqCategory } from '../faq-category';
import { FaqCategoryComponent } from '../faq-category/faq-category.component';

@Component({
    selector: 'app-faq-category-list',
    templateUrl: './faq-category-list.component.html',
    styleUrls: ['./faq-category-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class FaqCategoryListComponent implements OnInit {
	constructor(
		private faqCategoryService: FaqCategoryService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = faqCategoryService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	faqCategorys: any;
	faqCategory: FaqCategory;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'faqCategoryGroupId', header: 'Group Name', width: 'auto' },
		{ field: 'enabled', header: 'Enabled', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.faqCategoryId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-faqCategory-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.faqCategoryService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.faqCategorys = res.data.faqCategorys;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.faqCategorys = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(faqCategory: FaqCategory) {
		try {
			this.formLoading = true;
			this.faqCategoryService.update(faqCategory)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.faqCategorys.map((faqCategory, i) => {
							if (faqCategory.faqCategoryId === res.data.faqCategory.faqCategoryId) {
								this.faqCategorys[i] = res.data.faqCategory;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(faqCategory: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(faqCategory));

			this.formLoading = true;
			this.faqCategoryService.delete(faqCategory.faqCategoryId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.faqCategorys.splice(this.faqCategorys.indexOf(faqCategory), 1);
						this.recordTotal = this.faqCategorys.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'FaqCategory ' + faqCategory.faqCategoryId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'FaqCategory ' + faqCategory.faqCategoryId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add FaqCategory'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FaqCategoryComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addFaqCategoryCB(data);

				// close the dialogBox
				// dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(faqCategory: FaqCategory) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			faqCategory: faqCategory,
			title: 'Edit FaqCategory'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FaqCategoryComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateFaqCategoryCB(data);

				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteFaqCategoryCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addFaqCategoryCB(faqCategory: FaqCategory) {
		console.log('Adding FaqCategory: ' + JSON.stringify(faqCategory));
		// if we don't have a faqCategorys array yet...
		if (!this.faqCategorys) {
			this.faqCategorys = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.faqCategorys.unshift(faqCategory);

		// no idea what this is but it is required to update the array
		this.faqCategorys = [...this.faqCategorys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqCategory ' + faqCategory.faqCategoryId + ' Added', life: 3000 });
	}

	updateFaqCategoryCB(faqCategory: FaqCategory) {
		console.log('Updating FaqCategory: ' + JSON.stringify(faqCategory));
		let itemIndex = this.faqCategorys.findIndex((item: any) => item.faqCategoryId === faqCategory.faqCategoryId);
		this.faqCategorys[itemIndex] = faqCategory;

		// no idea what this is but it is required to update the array
		this.faqCategorys = [...this.faqCategorys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqCategory ' + faqCategory.faqCategoryId + ' Updated', life: 3000 });
	}

	deleteFaqCategoryCB(faqCategory: FaqCategory) {
		console.log('Removing FaqCategory: ' + faqCategory);
		this.faqCategorys.splice(this.faqCategorys.indexOf(faqCategory), 1);
		this.recordTotal = this.faqCategorys.length;

		// no idea what this is but it is required to update the array
		this.faqCategorys = [...this.faqCategorys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqCategory ' + faqCategory.faqCategoryId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.faqCategorys ? this.first === (this.faqCategorys.length - this.rows) : true; }
	isFirstPage(): boolean { return this.faqCategorys ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(faqCategory: any) {
		if (faqCategory?.status) {
			const status = this.statuses.find((e: any) => e.value == faqCategory.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
